import type { SVGProps } from 'react';
const SvgOrganicFlask = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <desc>{'Organic Flask Streamline Icon: https://streamlinehq.com'}</desc>
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.932 17s1.22 2.495 3.27 2.307c4.158-.38 3.88-5.907 5.4-7.859a9.1 9.1 0 0 0-8.265.075c-2.154 1.221-2.306 3.277-.405 5.477"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.873 14.469s-2.7.334-4.623 5.03"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m21.747 18.86 1.3 2.129a1.5 1.5 0 0 1-1.297 2.261H2.25a1.5 1.5 0 0 1-1.293-2.261L8.25 9V.75M15.75.75V7.5M6 .75h12M15.75 3.75H13.5M15.75 6.75H13.5"
    />
  </svg>
);
export default SvgOrganicFlask;
